import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import api from "@/lib/api";
import OrdenesTab from "@/components/compras/OrdenesTab";
import ProveedoresTab from "@/components/compras/ProveedoresTab";
import IncidenciasProveedorTab from "@/components/compras/IncidenciasProveedorTab";
import EquivalenciasTab from "@/components/compras/EquivalenciasTab";
import HistorialPreciosTab from "@/components/compras/HistorialPreciosTab";
import PedidoCentral from "@/components/compras/PedidoCentral";
import BuscadorEscaneo from "@/components/stock/BuscadorEscaneo";

const TABS = [["ordenes", "Órdenes de compra"], ["incidencias", "Incidencias proveedor"], ["proveedores", "Proveedores"], ["equivalencias", "Equivalencias SKU"], ["precios", "Historial de precios"]];

export default function Compras() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "ordenes";
  const [proveedores, setProveedores] = useState([]);
  const [comps, setComps] = useState([]);
  const [resumen, setResumen] = useState(null);
  const [modo, setModo] = useState(null);

  const cargarBase = () => {
    api.get("/compras/modo").then((r) => setModo(r.data)).catch(() => setModo({ modo: "proveedores" }));
    api.get("/compras/proveedores").then((r) => setProveedores(r.data)).catch(() => {});
    api.get("/componentes").then((r) => setComps(r.data)).catch(() => {});
    api.get("/compras/resumen").then((r) => setResumen(r.data)).catch(() => {});
  };
  useEffect(cargarBase, []);

  const setTab = (t) => { const p = new URLSearchParams(params); p.set("tab", t); p.delete("orden"); setParams(p); };

  if (modo?.modo === "almacen_central") return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-[1400px] mx-auto animate-fade-up" data-testid="compras-page">
      <div className="mb-6"><div className="eyebrow mb-1">Operación · Abastecimiento</div><h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-brand-ink flex items-center gap-2"><ShoppingBag className="w-7 h-7 text-brand-amber" /> Pedido a {modo.almacen?.nombre || "Almacén Central"}</h1><p className="text-sm text-brand-muted mt-1">Tu único proveedor es el Almacén Central CDMX. Arma el pedido con sugerencia por consumo y precios de la lista Almacén Oaxaca; puedes pedir aunque CDMX no tenga existencia en ese momento. Recíbelo aquí mismo con escáner.</p></div>
      <PedidoCentral modo={modo} />
    </div>
  );

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-[1400px] mx-auto animate-fade-up" data-testid="compras-page">
      <div className="flex items-start justify-between flex-wrap gap-4 mb-6">
        <div><div className="eyebrow mb-1">Operación · Almacén Central</div><h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-brand-ink flex items-center gap-2"><ShoppingBag className="w-7 h-7 text-brand-amber" /> Compras a proveedor</h1><p className="text-sm text-brand-muted mt-1">Órdenes de compra con nombres del proveedor, recepción por CFDI/remisión y actualización de costos (promedio ponderado) con tu confirmación.</p></div>
        {resumen && <div className="grid grid-cols-2 sm:flex gap-2 text-xs w-full sm:w-auto" data-testid="compras-resumen">{[["Borradores", resumen.borrador], ["Enviadas / parciales", resumen.enviadas], ["Recepciones por confirmar", resumen.recepciones_pendientes], ["Proveedores", resumen.proveedores]].map(([l, v]) => <div key={l} className="surface-card px-3 py-2"><div className="text-[10px] uppercase text-brand-muted font-bold">{l}</div><div className="font-display font-extrabold text-lg text-brand-ink">{v}</div></div>)}</div>}
        <BuscadorEscaneo />

      </div>
      <div className="flex flex-wrap gap-1 mb-5" data-testid="compras-tabs">{TABS.map(([k, lab]) => <button key={k} data-testid={`compras-tab-${k}`} onClick={() => setTab(k)} className={`h-9 px-4 rounded-full text-sm font-bold transition-colors ${tab === k ? "bg-brand-ink text-white" : "bg-brand-surface text-brand-slate hover:bg-brand-line"}`}>{lab}</button>)}</div>
      {tab === "ordenes" && <OrdenesTab proveedores={proveedores} comps={comps} ordenInicial={params.get("orden")} onCambio={cargarBase} />}
      {tab === "incidencias" && <IncidenciasProveedorTab />}
      {tab === "proveedores" && <ProveedoresTab proveedores={proveedores} onCambio={cargarBase} />}
      {tab === "equivalencias" && <EquivalenciasTab proveedores={proveedores} comps={comps} />}
      {tab === "precios" && <HistorialPreciosTab proveedores={proveedores} comps={comps} />}
    </div>
  );
}
